import { Feature } from '@pletly/shared';

import { User } from '../Auth';

export function reducer(prevState: AuthState, action: Action): AuthState {
	switch (action.type) {
		case 'RESTORE_TOKEN':
			return {
				...prevState,
				userToken: action.token,
				mediaToken: action.mediaToken,
				user: action.user,
				features: action.features,
				isLoading: false,
				callbackUrl: action.callbackUrl || undefined,
			};
		case 'SIGN_IN':
			return {
				...prevState,
				isSignout: false,
				userToken: action.token,
				mediaToken: action.mediaToken,
				user: action.user,
				features: action.features,
				isSignedInCurrentAppRun: true,
				callbackUrl: action.callbackUrl,
			};
		case 'SIGN_OUT':
			return {
				...prevState,
				isSignout: true,
				userToken: null,
				mediaToken: null,
			};
		case 'FINISH_LOADING':
			return {
				...prevState,
				isLoading: false,
			};
		default:
			return prevState;
	}
}

export type AuthState = {
	isLoading: boolean;
	isSignout: boolean;
	isSignedInCurrentAppRun: boolean;
	callbackUrl?: string;
} & UserData;

type UserData =
	| {
			userToken: string;
			mediaToken: string;
			user?: User;
			features: Feature[];
	  }
	| {
			userToken: null;
			mediaToken: null;
	  };

export type Action =
	| {
			type: 'RESTORE_TOKEN';
			token: string;
			mediaToken: string;
			user: User;
			features: Feature[];
			callbackUrl?: string | null;
	  }
	| {
			type: 'SIGN_IN';
			token: string;
			mediaToken: string;
			user: User;
			features: Feature[];
			callbackUrl?: string;
	  }
	| { type: 'SIGN_OUT'; error?: string }
	| { type: 'FINISH_LOADING' };
